import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import blogData from "../../../data/blogs/Blog.json";
import Navbar from "../../Navbar/Navbar";
import Main_Footer from "../../footer/IndiaFooter/Main_Footer";
import Banner from "../../body/topLocationsComponents/Banner";
import { BannerData } from "../../../Location/data";
import { useParams } from "react-router-dom";
import { FiSearch, FiCalendar, FiTag, FiArrowRight } from "react-icons/fi";

const categories = [
  { name: "Real Estate News", count: 12 },
  { name: "Gurugram News", count: 8 },
  { name: "Pune News", count: 5 },
  { name: "Mumbai News", count: 7 },
  { name: "Bangaluru News", count: 3 },
];

const tags = [
  "Luxury Homes",
  "Investment",
  "Interior Design",
  "Market Analysis",
  "Home Loans",
  "Property Tips",
  "Real Estate News",
  "Home Buying",
];


// Helper function to find all occurrences of a substring in a string
const findAllIndices = (str, searchStr) => {
  const indices = [];
  let startIndex = 0;
  let index;
  
  while ((index = str.toLowerCase().indexOf(searchStr.toLowerCase(), startIndex)) > -1) {
    indices.push(index);
    startIndex = index + searchStr.length;
  }
  
  return indices;
};

// Helper function to render content with links
const renderContentWithLinks = (content) => {
  if (!content) return null;
  
  // If content is a string (for backward compatibility)
  if (typeof content === 'string') {
    return <p className="text-base text-gray-700 leading-relaxed">{content}</p>;
  }
  
  // If content is an object with text and links
  if (content.text && Array.isArray(content.links)) {
    const text = content.text;
    const elements = [];
    
    // Process links that have a position specified
    const positionedLinks = content.links.filter(link => typeof link.position === 'number' && !link.skip);
    
    // Create a map of positions to links
    const positionMap = new Map();
    positionedLinks.forEach(link => {
      const indices = findAllIndices(text, link.text);
      const positionIndex = link.position - 1; // Convert to 0-based index
      
      if (positionIndex >= 0 && positionIndex < indices.length) {
        const startPos = indices[positionIndex];
        const endPos = startPos + link.text.length;
        positionMap.set(startPos, { endPos, link });
      }
    });
    
    // Sort positions in descending order to handle replacements from end to start
    const sortedPositions = Array.from(positionMap.keys()).sort((a, b) => b - a);
    
    // Build the result by replacing text at specific positions
    let result = [];
    let lastIndex = text.length;
    
    for (const startPos of sortedPositions) {
      const { endPos, link } = positionMap.get(startPos);
      
      // Add text after the current link
      if (endPos < lastIndex) {
        result.unshift(text.substring(endPos, lastIndex));
      }
      
      // Add the link
      result.unshift(
        <a
          key={`${startPos}-${endPos}`}
          href={link.url}
          className="text-blue-600 hover:text-blue-800 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {text.substring(startPos, endPos)}
        </a>
      );
      
      lastIndex = startPos;
    }
    
    // Add remaining text at the beginning
    if (lastIndex > 0) {
      result.unshift(text.substring(0, lastIndex));
    }
    
    return <p className="text-base text-gray-700 leading-relaxed">{result}</p>;
  }
  
  return null;
};

const BlogDetailTwo = () => {
  const { slug } = useParams();
  const blogMain = blogData.find((blog) => blog.slug === slug);

  if (!blogMain) {
    return <div className="text-center mt-10">Blog not found</div>;
  }
  
  // Get popular posts (first 3 posts for demo)
  const popularPosts = useMemo(() => {
    return [...blogData].slice(0, 3);
  }, [blogData]);

  return (
    <>
      <Navbar />
      <Banner BannerData={BannerData} />
      <div
        className="blog detail2 border-t border-gray-200"
        style={{ fontFamily: "InstrumentSans" }}
      >
        <div className="container pt-5 md:pt-10 lg:pt-16">
          <div className="blog-content flex flex-col lg:flex-row justify-between gap-10">

            <div className="main w-full lg:w-2/3 xl:w-3/4 lg:pr-6">


              <h1 className="heading3 ">{blogMain.h1Heading}</h1>

              <div className="author flex items-center gap-4 mt-4 text-sm text-gray-500">
                <div className="flex items-center gap-3">
                  <div className="caption1">By {blogMain.author}</div>
                  <div className="w-4 h-px bg-gray-300"></div>
                  <div className="caption1">{blogMain.date}</div>
                </div>
              </div>

              <div className="bg-img py-6 md:py-10">
                <img
                  src={blogMain.thumbImg}
                  alt={blogMain.thumbImg}
                  className="w-full object-cover rounded-2xl"
                />
              </div>

              <div className="space-y-10">
                {/* Section 1 */}
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                    {blogMain.h1Heading}
                  </h2>
                  {renderContentWithLinks(blogMain.h1Content)}
                </section>

                {/* Section 2 */}
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                    {blogMain.h2Heading}
                  </h2>
                  {renderContentWithLinks(blogMain.h2Content)}
                </section>

                {/* Section 3 */}
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                    {blogMain.h3Heading}
                  </h2>
                  {renderContentWithLinks(blogMain.h3Content)}
                </section>

                {/* Section 4 */}
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                    {blogMain.h4Heading}
                  </h2>
                  {renderContentWithLinks(blogMain.h4Content)}
                </section>

                {/* Section 5 */}
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                    {blogMain.h5Heading}
                  </h2>
                  {renderContentWithLinks(blogMain.h5Content)}
                </section>
              </div>



            </div>

            {/* Sidebar */}
            <div className="xl:w-1/4 md:w-full hidden md:block">
              {/* Popular Posts */}
              <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6 mb-8">
                <h3 className="text-xl font-semibold mb-6">Popular Posts</h3>
                <div className="space-y-6">
                  {popularPosts.map((post, index) => (
                    <div
                      key={index}
                      className="flex gap-3 group cursor-pointer"
                    >
                      <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={post.thumbImg}
                          alt={post.h1Heading}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        />
                      </div>
                      <div>
                        <h4 className="text-lg font-medium text-gray-800 group-hover:text-primary transition-colors line-clamp-2">
                          {post.h1Heading}
                        </h4>
                        <div className="flex items-center text-sm text-gray-500 mt-1">
                          <FiCalendar className="mr-1.5" size={14} />
                          <span>{post.date}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Categories */}
              {/* <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6 mb-8">
                <h3 className="text-xl font-semibold mb-6">Categories</h3>
                <ul className="space-y-3">
                  {categories.map((category, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center group cursor-pointer"
                    >
                      <div className="flex items-center">
                        <FiTag
                          className="mr-2 text-gray-400 group-hover:text-primary transition-colors"
                          size={16}
                        />
                        <span className="text-gray-600 group-hover:text-primary transition-colors">
                          {category.name}
                        </span>
                      </div>
                      <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {category.count}
                      </span>
                    </li>
                  ))}
                </ul>
              </div> */}

              {/* Popular Tags */}
              {/* <div className="bg-[#F7F7F7] rounded-xl border border-gray-100 p-6">
                <h3 className="text-xl font-semibold mb-6">Popular Tags</h3>
                <div className="flex flex-wrap gap-2">
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center bg-gray-50 hover:bg-primary hover:text-gray text-gray-600 text-sm px-3 py-1.5 rounded-full transition-colors cursor-pointer border border-gray-200 hover:border-primary"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div> */}

              {/* Newsletter Signup */}
              <div className="bg-[#F7F7F7] rounded-xl p-6 mt-8 text-black border border-gray-100">
                <h3 className="text-xl font-semibold mb-3">
                  Subscribe to Our Newsletter
                </h3>
                <p className="text-sm   mb-4">
                  Get the latest property news and updates delivered to your
                  inbox.
                </p>
                <div className="relative">
                  <input
                    type="email"
                    placeholder="Your email address"
                    className="w-full bg-white/20 backdrop-blur-sm border border-white/30 rounded-lg py-3 px-4 pr-10 text-black placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary/50"
                  />
                  <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white text-black p-1.5 rounded-md hover:bg-gray-100 transition-colors">
                    <FiArrowRight size={20} />
                  </button>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <Main_Footer />
    </>
  );
};

export default BlogDetailTwo;
